module.exports = __webpack_public_path__ + "static/img/1bd6b15a09438cb9f7ca41c908166277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_active_05.png
// module id = xdkf
// module chunks = 1